import { c as _c } from "react/compiler-runtime";
import React, { Children, Fragment, isValidElement } from 'react';
import { FieldInputProps, FieldRenderProps } from 'react-final-form';
import Select, { GroupBase, PlaceholderProps, SingleValue, components } from 'react-select';
import DownIcon from '@/assets/icons/heroIcons/Down.svg';
import { mergeClasses } from '@/utils/style';
import { ErrorMessage } from '../ErrorMessage';
import { useSheet } from '@/components/Sheet/Sheet';
import SheetItem from '@/components/Sheet/SheetItem';
export const MOBILE_OPTION_HEIGHT = 48;
export const MOBILE_GROUP_LABEL_HEIGHT = 36;
export const MOBILE_SHEET_HEADER_HEIGHT = 40;
export const MOBILE_SHEET_BOTTOM_PADDING = 32;
interface Option {
  label: string;
  value: string;
}
interface OptionGroup {
  label: string;
  options: Option[];
}
type CustomProps = {
  label: string;
  hideLabel?: boolean;
  onSelect?: (value: string | undefined) => void;
};
function isOptionGroup(option: Option | OptionGroup): option is OptionGroup {
  return Array.isArray((option as OptionGroup).options);
}
export function SelectInput(props) {
  const $ = _c(74);
  const hasError = props.meta.error && props.meta.touched;
  const errorId = `${props.input.name}-error`;
  const options = props.options;
  const flatOptions = options.flatMap(_temp);
  let t0;
  if ($[0] !== options) {
    t0 = options.filter(isOptionGroup);
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const groupCount = t0.length;
  let t1;
  if ($[2] !== groupCount || $[3] !== props) {
    t1 = t2 => {
      const {
        label,
        value
      } = t2;
      return <SheetItem onClick={() => {
        props.input.onChange(value);
        props.onSelect?.(value);
      }} key={value} className={groupCount > 0 ? "px-8" : undefined} isActive={value === props.input.value}>{label}</SheetItem>;
    };
    $[2] = groupCount;
    $[3] = props;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const renderSheetOption = t1;
  let t2;
  if ($[5] !== options || $[6] !== renderSheetOption) {
    t2 = () => <div className="max-h-[85vh] overflow-auto">{options.map(option_0 => isOptionGroup(option_0) ? <Fragment key={option_0.label}><p className="px-6 py-2 text-sm text-gray-700">{option_0.label}</p>{option_0.options.map(renderSheetOption)}</Fragment> : renderSheetOption(option_0))}</div>;
    $[5] = options;
    $[6] = renderSheetOption;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const t3 = flatOptions.length * MOBILE_OPTION_HEIGHT + groupCount * MOBILE_GROUP_LABEL_HEIGHT + MOBILE_SHEET_HEADER_HEIGHT + MOBILE_SHEET_BOTTOM_PADDING;
  let t4;
  if ($[8] !== t3) {
    t4 = {
      withCloseIcon: true,
      closeOnSelect: true,
      snapPoints: [t3]
    };
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const [sheet, openSheet] = useSheet(t2, t4);
  const t5 = props.className;
  const t6 = "true";
  const t7 = props.label;
  const t8 = props.input.name;
  const t9 = !props.hideLabel && props.input.value !== "";
  const t10 = props.hideLabel && props.input.value !== "";
  let t11;
  if ($[10] !== t10 || $[11] !== t9) {
    t11 = mergeClasses("label", {
      "animated-label": t9,
      hidden: t10
    });
    $[10] = t10;
    $[11] = t9;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== props.input.name || $[14] !== props.label || $[15] !== t11) {
    t12 = <label htmlFor={t8} className={t11}>{props.label}</label>;
    $[13] = props.input.name;
    $[14] = props.label;
    $[15] = t11;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  const t13 = props.input.name;
  const t14 = props.label;
  const t15 = hasError ? errorId : undefined;
  const t16 = hasError ? "true" : "false";
  const t17 = props.input as FieldInputProps<string, HTMLElement>;
  let t18;
  if ($[17] !== options) {
    t18 = options.map(_temp3);
    $[17] = options;
    $[18] = t18;
  } else {
    t18 = $[18];
  }
  let t19;
  if ($[19] !== props.input.name || $[20] !== props.label || $[21] !== t15 || $[22] !== t16 || $[23] !== t17 || $[24] !== t18) {
    t19 = <select id={t13} className="input pointer-events-none appearance-none pr-8 pl-3 text-ellipsis whitespace-nowrap" aria-label={t14} aria-describedby={t15} aria-invalid={t16} {...t17}>{t18}</select>;
    $[19] = props.input.name;
    $[20] = props.label;
    $[21] = t15;
    $[22] = t16;
    $[23] = t17;
    $[24] = t18;
    $[25] = t19;
  } else {
    t19 = $[25];
  }
  let t20;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <span className="iconContainer absolute top-1/2 right-3 block h-6 w-6 -translate-y-1/2"><DownIcon aria-hidden="true" /></span>;
    $[26] = t20;
  } else {
    t20 = $[26];
  }
  let t21;
  if ($[27] !== openSheet || $[28] !== props.label || $[29] !== t12 || $[30] !== t19) {
    t21 = <button type="button" onClick={openSheet} className="relative w-full text-left" aria-haspopup="dialog" aria-label={t7}>{t12}{t19}{t20}</button>;
    $[27] = openSheet;
    $[28] = props.label;
    $[29] = t12;
    $[30] = t19;
    $[31] = t21;
  } else {
    t21 = $[31];
  }
  let t22;
  if ($[32] !== sheet || $[33] !== t21) {
    t22 = <div className="md:hidden">{t21}{sheet}</div>;
    $[32] = sheet;
    $[33] = t21;
    $[34] = t22;
  } else {
    t22 = $[34];
  }
  const t23 = "hidden md:block";
  const T0 = Select;
  let t24;
  if ($[35] !== props) {
    t24 = value_1 => {
      props.input.onChange(value_1?.value);
      props.onSelect?.(value_1?.value);
    };
    $[35] = props;
    $[36] = t24;
  } else {
    t24 = $[36];
  }
  const t25 = true;
  const t26 = flatOptions.find(option_2 => option_2.value === props.input.value) || undefined;
  const t27 = hasError ? errorId : undefined;
  const t28 = hasError ? "true" : "false";
  let t29;
  if ($[37] !== props.hideLabel) {
    t29 = !props.hideLabel && {
      ValueContainer: _temp7
    };
    $[37] = props.hideLabel;
    $[38] = t29;
  } else {
    t29 = $[38];
  }
  let t30;
  if ($[39] !== t29) {
    t30 = {
      IndicatorSeparator: _temp4,
      DropdownIndicator: _temp5,
      ...t29
    };
    $[39] = t29;
    $[40] = t30;
  } else {
    t30 = $[40];
  }
  let t31;
  if ($[41] !== props.hideLabel) {
    t31 = () => mergeClasses("input border-light-gray-500 rounded-lg pr-3", {
      "justify-end!": !props.hideLabel
    });
    $[41] = props.hideLabel;
    $[42] = t31;
  } else {
    t31 = $[42];
  }
  let t32;
  if ($[43] !== props.meta.visited) {
    t32 = () => mergeClasses("max-w-[95%]! overflow-hidden", {
      "text-gray-600": !props.meta.visited
    });
    $[43] = props.meta.visited;
    $[44] = t32;
  } else {
    t32 = $[44];
  }
  let t33;
  if ($[45] !== props.hideLabel) {
    t33 = t34 => {
      const {
        isFocused,
        hasValue
      } = t34;
      return mergeClasses("label top-0 left-0 text-gray-600", {
        "animated-label px-1 -left-1": !props.hideLabel && (isFocused || hasValue)
      });
    };
    $[45] = props.hideLabel;
    $[46] = t33;
  } else {
    t33 = $[46];
  }
  let t34;
  if ($[47] !== groupCount) {
    t34 = t35 => {
      const {
        isFocused: isFocused_0,
        isSelected
      } = t35;
      return mergeClasses("py-3 cursor-pointer!", groupCount > 0 ? "px-8" : "px-4", {
        "bg-gray-50 font-semibold text-gray-900": isSelected
      }, {
        "bg-blue-50": isFocused_0
      });
    };
    $[47] = groupCount;
    $[48] = t34;
  } else {
    t34 = $[48];
  }
  let t35;
  if ($[49] !== t31 || $[50] !== t32 || $[51] !== t33 || $[52] !== t34) {
    t35 = {
      control: t31,
      valueContainer: _temp8,
      singleValue: t32,
      input: _temp9,
      placeholder: t33,
      menu: _temp10,
      groupHeading: _temp11,
      option: t34
    };
    $[49] = t31;
    $[50] = t32;
    $[51] = t33;
    $[52] = t34;
    $[53] = t35;
  } else {
    t35 = $[53];
  }
  let t36;
  if ($[54] !== T0 || $[55] !== options || $[56] !== props.input || $[57] !== props.label || $[58] !== t24 || $[59] !== t26 || $[60] !== t27 || $[61] !== t28 || $[62] !== t30 || $[63] !== t35) {
    t36 = <div className={t23}><T0 {...props.input} onChange={t24} unstyled={t25} value={t26} options={options} isSearchable={false} placeholder={props.label} aria-describedby={t27} aria-invalid={t28} components={t30} classNames={t35} /></div>;
    $[54] = T0;
    $[55] = options;
    $[56] = props.input;
    $[57] = props.label;
    $[58] = t24;
    $[59] = t26;
    $[60] = t27;
    $[61] = t28;
    $[62] = t30;
    $[63] = t35;
    $[64] = t36;
  } else {
    t36 = $[64];
  }
  let t37;
  if ($[65] !== errorId || $[66] !== hasError || $[67] !== props.meta.error) {
    t37 = hasError && <ErrorMessage error={props.meta.error} id={errorId} />;
    $[65] = errorId;
    $[66] = hasError;
    $[67] = props.meta.error;
    $[68] = t37;
  } else {
    t37 = $[68];
  }
  let t38;
  if ($[69] !== props.className || $[70] !== t22 || $[71] !== t36 || $[72] !== t37) {
    t38 = <div className={t5} data-clarity-mask={t6}>{t22}{t36}{t37}</div>;
    $[69] = props.className;
    $[70] = t22;
    $[71] = t36;
    $[72] = t37;
    $[73] = t38;
  } else {
    t38 = $[73];
  }
  return t38;
}
function _temp11() {
  return "px-5 py-2 text-sm font-normal text-gray-700";
}
function _temp10() {
  return "rounded-lg bg-white mt-2 border border-gray-100 z-50! shadow-none [&>div]:py-0 [&>div]:rounded-lg";
}
function _temp9() {
  return "p-0 m-0 text-gray-900";
}
function _temp8() {
  return "p-0! flex! overflow-visible! w-[calc(100%-1.5rem)]";
}
function _temp7(t0) {
  const {
    children,
    ...valueContainerProps
  } = t0;
  if (valueContainerProps.innerProps) {
    const placeholderProps = {
      ...valueContainerProps,
      children: valueContainerProps.selectProps.placeholder,
      innerProps: valueContainerProps.innerProps,
      isFocused: valueContainerProps.selectProps.menuIsOpen
    };
    return <components.ValueContainer {...valueContainerProps}><components.Placeholder {...placeholderProps}>{valueContainerProps.selectProps.placeholder}</components.Placeholder>{Children.map(children, _temp6)}</components.ValueContainer>;
  }
}
function _temp6(child) {
  return isValidElement(child) && child.type !== components.Placeholder ? child : null;
}
function _temp5(dropdownProps) {
  return <components.DropdownIndicator {...dropdownProps} className="p-0!"><span className={mergeClasses("transition-transform", dropdownProps.selectProps.menuIsOpen ? "rotate-180" : "rotate-0")}><DownIcon /></span></components.DropdownIndicator>;
}
function _temp4() {
  return null;
}
function _temp3(option_1) {
  return isOptionGroup(option_1) ? <optgroup key={option_1.label} label={option_1.label}>{option_1.options.map(_temp2)}</optgroup> : <option key={option_1.value} value={option_1.value}>{option_1.label}</option>;
}
function _temp2(t0) {
  const {
    label: label_0,
    value: value_0
  } = t0;
  return <option key={value_0} value={value_0}>{label_0}</option>;
}
function _temp(option) {
  return isOptionGroup(option) ? option.options : [option];
}